import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileText, DollarSign, ClipboardList, Trash2 } from 'lucide-react';
import { COMPANY } from '../../config/company';
import { toast } from 'sonner';

const EstimateTypeSelectorCard = ({
  language,
  lead,
  setLead,
  handleInputChange,
  setAiEstimateType,
  setAiGeneratedEstimate,
  setAiItemizedEstimate
}) => {
  return (
    <Card className="border-2 border-amber-300">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <FileText className="h-6 w-6 text-amber-600" />
            <div>
              <p className="font-semibold text-gray-800">
                {language === 'es' ? 'Tipo de Presupuesto' : 'Estimate Type'}
              </p>
              <p className="text-xs text-gray-500">
                {language === 'es' ? 'Seleccione el formato del presupuesto' : 'Select the estimate format'}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant={lead.estimate_type !== 'lump_sum' ? 'default' : 'outline'}
              style={lead.estimate_type !== 'lump_sum' ? { backgroundColor: COMPANY.primaryColor } : {}}
              onClick={() => {
                if (lead.estimate_type === 'lump_sum') {
                  const hasLumpSumItems = (lead.lump_sum_items?.length || 0) > 0;
                  if (hasLumpSumItems) {
                    const confirmSwitch = window.confirm(
                      language === 'es' 
                        ? '¿Cambiar a Detallado? Los items de Suma Global se mantendrán. Use el generador AI para crear nuevos items detallados.'
                        : 'Switch to Itemized? Lump Sum items will be kept. Use AI Generator to create new itemized items.'
                    );
                    if (confirmSwitch) {
                      handleInputChange('estimate_type', 'itemized');
                      setAiEstimateType('itemized');
                    }
                  } else {
                    handleInputChange('estimate_type', 'itemized');
                    setAiEstimateType('itemized');
                  }
                }
              }}
            >
              <DollarSign className="h-4 w-4 mr-1" />
              {language === 'es' ? 'Detallado' : 'Itemized'}
            </Button>
            <Button
              size="sm"
              variant={lead.estimate_type === 'lump_sum' ? 'default' : 'outline'}
              style={lead.estimate_type === 'lump_sum' ? { backgroundColor: COMPANY.primaryColor } : {}}
              onClick={() => {
                if (lead.estimate_type !== 'lump_sum') {
                  const hasItemizedItems = (lead.line_items?.length || 0) > 0;
                  if (hasItemizedItems) {
                    const confirmSwitch = window.confirm(
                      language === 'es' 
                        ? '¿Cambiar a Suma Global? Los items detallados se mantendrán. Use el generador AI para crear un nuevo alcance.'
                        : 'Switch to Lump Sum? Itemized items will be kept. Use AI Generator to create new scope.'
                    );
                    if (confirmSwitch) {
                      handleInputChange('estimate_type', 'lump_sum');
                      setAiEstimateType('lump_sum');
                    }
                  } else {
                    handleInputChange('estimate_type', 'lump_sum');
                    setAiEstimateType('lump_sum');
                  }
                }
              }}
            >
              <ClipboardList className="h-4 w-4 mr-1" />
              {language === 'es' ? 'Suma Global' : 'Lump Sum'}
            </Button>
            {/* Clear & Start Fresh Button */}
            {((lead.line_items?.length || 0) > 0 || (lead.lump_sum_items?.length || 0) > 0 || (lead.misc_items?.length || 0) > 0) && (
              <Button
                size="sm"
                variant="ghost"
                className="text-red-500 hover:text-red-700 hover:bg-red-50"
                data-testid="clear-estimate-btn"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const confirmClear = window.confirm(
                    language === 'es' 
                      ? '¿Borrar todos los items del estimado actual? Esto no se puede deshacer.'
                      : 'Clear all items from current estimate? This cannot be undone.'
                  );
                  if (confirmClear) {
                    setLead(prev => ({
                      ...prev,
                      line_items: [],
                      lump_sum_items: [],
                      misc_items: [],
                      lump_sum_total: 0,
                      subtotal: 0,
                      tax_amount: 0,
                      total: 0
                    }));
                    setAiGeneratedEstimate(null);
                    setAiItemizedEstimate([]);
                    toast.success(language === 'es' ? 'Estimado limpiado' : 'Estimate cleared');
                  }
                }}
              >
                <Trash2 className="h-4 w-4 mr-1" />
                {language === 'es' ? 'Limpiar' : 'Clear'}
              </Button>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EstimateTypeSelectorCard;
